module.exports = __webpack_public_path__ + "img/28.caf954d2.webp";